import { Box, createStyles, makeStyles, Paper, Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';

import { CONSTANTS } from '../../../../core/config/constants';
import { border } from '../../../../core/utils/theme.utils';
import { TabItem } from '../../Company/CompanyTabs/CompanyTabs';
import { MyFilters } from './MyFilters/MyFilters';
import { PredefinedFilters } from './PredefinedFilters/PredefinedFilters';

interface Props {}

export const TabNamesEnum = {
  PREDEFINED_FILTERS: 'companies:queriesPanel:popularFilters',
  MY_FILTERS: 'companies:queriesPanel:myFilters',
  ASSIST: 'companies:queriesPanel:assist',
};
const tabItems: TabItem[] = [
  { name: TabNamesEnum.PREDEFINED_FILTERS, component: <PredefinedFilters /> },
  { name: TabNamesEnum.MY_FILTERS, component: <MyFilters /> },
];
export const QueriesPanel: React.FC<Props> = () => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(tabItems[0].name);
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<{}>, tab: string) => {
    ReactGA.event({ category: 'SEARCH', action: 'FILTER_TAB_CLICK', label: tab });
    setActiveTab(tab);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.tabsContainer}>
        <Paper square className={classes.tabItems}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            className={classes.menuTabs}
          >
            {tabItems.map((tab: TabItem) => {
              return (
                <Tab
                  id={`full-width-tab-${tab.name}`}
                  key={tab.name}
                  value={tab.name}
                  label={t(tab.name)}
                />
              );
            })}
          </Tabs>
        </Paper>
        <Box className={classes.tabsBox}>
          {tabItems.map((tab: TabItem) => {
            return (
              activeTab === tab.name && (
                <Box role="tabpanel" id={`full-width-tabpanel-${tab.name}`} key={tab.name}>
                  {tab.component}
                </Box>
              )
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      borderLeft: border(theme.palette.divider),
      borderRight: border(theme.palette.divider),
    },
    tabsBox: {
      overflowY: 'auto',
      height: 'calc(100vh - 80px)',
    },
    tabItems: {
      marginBottom: theme.spacing(8),
      height: CONSTANTS.TOOLBAR_HEIGHT,
    },
    menuTabs: {
      minHeight: CONSTANTS.TOOLBAR_HEIGHT,
      height: CONSTANTS.TOOLBAR_HEIGHT,
    },
    tabsContainer: {
      position: 'relative',
      '& .Mui-selected': {
        '& .MuiTab-wrapper': {
          color: theme.palette.primary.main,
        },
      },
      '& .MuiTab-wrapper': {
        textTransform: 'capitalize',
        color: theme.palette.secondary.dark,
      },
      '& .MuiTab-root': {
        [theme.breakpoints.down('md')]: {
          minWidth: '100px',
        },
      },
    },
  }),
);
